// Libs
import React from 'react';
// Components
import OrdersOverview from '../OrdersOverview/OrdersOverview';

const OrdersTopay = props => (
	<OrdersOverview {...props} orderFlowType='orders_topay' />
);
export default OrdersTopay;
